
export enum OrderStatus {
  /// <summary>
  /// The not sent
  /// </summary>
  NotSent,
  /// <summary>
  /// The pending new
  /// </summary>
  PendingNew,
  /// <summary>
  /// The new
  /// </summary>
  New,
  /// <summary>
  /// The rejected
  /// </summary>
  Rejected,
  /// <summary>
  /// The partially filled
  /// </summary>
  PartiallyFilled,
  /// <summary>
  /// The filled
  /// </summary>
  Filled,
  /// <summary>
  /// The pending cancel
  /// </summary>
  PendingCancel,
  /// <summary>
  /// The cancelled
  /// </summary>
  Cancelled,
  /// <summary>
  /// The expired
  /// </summary>
  Expired,
  /// <summary>
  /// The pending replace
  /// </summary>
  PendingReplace,
  /// <summary>
  /// The replaced
  /// </summary>
  Replaced
}

export const isOrderCancellable = (status: OrderStatus): boolean => {
  return (
    status !== OrderStatus.Filled &&
    status !== OrderStatus.Cancelled &&
    status !== OrderStatus.Rejected &&
    status !== OrderStatus.Expired
  );
};

export enum OrderType
{
	/// <summary>
	/// Market order
	/// </summary>
	Market,
	/// <summary>
	/// Stop order
	/// </summary>
	Stop,
	/// <summary>
	/// Limit order
	/// </summary>
	Limit,
	/// <summary>
	/// Stop Limit order
	/// </summary>
	StopLimit,
	/// <summary>
	/// Market on Close order
	/// </summary>
	MarketOnClose,
	/// <summary>
	/// Pegged to Market order
	/// </summary>
	Pegged,
	/// <summary>
	/// Trailing Stop order
	/// </summary>
	TrailingStop,
	/// <summary>
	/// Trailing Stop Limit order
	/// </summary>
	TrailingStopLimit
}